import { createClient, type SupabaseClient } from "@supabase/supabase-js";

/**
 * Public Supabase client used by the marketing site to read auto-published
 * blog posts from the `blog_posts` table. Anon key is safe in the bundle —
 * RLS on `blog_posts` allows public read of `published_at IS NOT NULL` only.
 *
 * IMPORTANT: VITE_SUPABASE_URL must point at the same Supabase project the
 * Upfixe backend uses (where blogPublisher.ts inserts rows). If the marketing
 * site and backend target different projects, posts won't appear here.
 */
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as
  | string
  | undefined;

let cached: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient | null {
  if (cached) return cached;
  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn(
      "[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY not set — blog will use fallback posts only",
    );
    return null;
  }
  cached = createClient(supabaseUrl, supabaseAnonKey, {
    auth: { persistSession: false, autoRefreshToken: false },
  });
  return cached;
}
